import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AppContext } from './AppContext';

const PrivateRoute = ({ children }) => {
  const { getToken } = useContext(AppContext);
  const token = getToken();

  // If no token, redirect to login
  if (!token) {
    return <Navigate to="/login" replace />;
  }

  // Token exists, render protected content
  return children;
};

export default PrivateRoute;